export default function animateCSS(el: HTMLElement, animationName: string) {
    el.classList.add('animated', animationName);

    function handleAnimationEnd() {
        el.classList.remove('animated', animationName);
        el.removeEventListener('animationend', handleAnimationEnd);
    }

    el.addEventListener('animationend', handleAnimationEnd);
}
